Object.assign(exports, require('./sign-document'))
